
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonFloatMenu from '@/components/organisms/manage/ButtonFloatMenu.vue'
import { AcademyList } from '@/models/manage/AcademyList'

/**
 * 塾一覧テーブル
 */
@Component({
  components: {
    ButtonFloatMenu,
  },
})
export default class AcademyListTable extends Vue {
  /** 塾一覧 */
  @Prop()
  private academyList!: AcademyList[]

  /** 編集メニュー表示イベント */
  @Prop()
  private eventClickEditButton!: (event: Event, academyId: number) => Promise<void>
}
